/* Sold cars: "View all" expands the collapsed grid; make pills filter it.
   Pills are rendered by snippets/tc-make-filter.liquid; pinned/collapsed items by sections/tc-collection.liquid. */
(() => {
  const grid = document.querySelector('[data-tc-sold-grid]');
  if (!grid) return;
  const more = document.querySelector('[data-tc-sold-more]');

  const expand = () => {
    if (!grid.hasAttribute('data-collapsed')) return;
    grid.removeAttribute('data-collapsed');
    if (more) {
      more.setAttribute('aria-expanded', 'true');
      more.closest('.tc-sold-more')?.setAttribute('hidden', '');
    }
  };

  more?.addEventListener('click', () => {
    const first = grid.querySelector('li[data-tc-more]');
    expand();
    first?.querySelector('a')?.focus({ preventScroll: true });
  });

  const root = document.querySelector('[data-tc-makes]');
  if (!root) return;
  const small = (root.dataset.small || '').split('|').filter(Boolean);
  const pills = [...root.querySelectorAll('[data-make]')];
  const items = [...grid.children];
  const status = root.querySelector('[data-tc-makes-status]');

  const apply = (make, push) => {
    // A make choice shows every matching sold car, not just the pinned ones
    if (make) expand();
    let shown = 0;
    items.forEach((li) => {
      const match = !make || (make === 'other' ? small.includes(li.dataset.makeName) : li.dataset.make === make);
      li.hidden = !match;
      if (match) shown++;
    });
    pills.forEach((b) => {
      const on = b.dataset.make === make;
      b.classList.toggle('is-active', on);
      b.setAttribute('aria-pressed', on);
    });
    if (status) status.textContent = `${shown} sold ${shown === 1 ? 'car' : 'cars'} shown`;
    if (push) {
      const url = new URL(location.href);
      make ? url.searchParams.set('make', make) : url.searchParams.delete('make');
      url.hash = 'sold';
      history.replaceState(null, '', url);
    }
  };

  root.addEventListener('click', (e) => {
    const b = e.target.closest('[data-make]');
    if (b) apply(b.dataset.make, true);
  });

  const initial = new URLSearchParams(location.search).get('make');
  if (initial && pills.some((b) => b.dataset.make === initial)) apply(initial, false);
})();
